<template>
  <div :class="divWidthChange" class="conteudoWidth">
    <fccTitlePage :titlePage="titlePage"></fccTitlePage>
    <b-row align-v="baseline">
      <div class="col-sm-2">
        <fcc-select
          v-model="spi"
          @change="ListandoCandidatosDeficienciaAuditiva()"
          placeholder="Selecione a SPI"
          v-if="!todos"
          :clearable="false"
          :options="lstSpi"
          >SPI em andamento</fcc-select
        >
        <fcc-spi v-model="spi" @input="ListandoCandidatosDeficienciaAuditiva()" v-else></fcc-spi>
      </div>
      <div class="col-sm-3">
        <b-form-checkbox v-model="todos" name="checkbox-1"> Ver todas SPI </b-form-checkbox>
      </div>
    </b-row>
    <div class="row mt-3" v-if="mostraCandidatos">
      <div class="col-sm-12">
        <fccTable
          striped
          hover
          :fields="fieldsCandidatos"
          responsive
          :porPage="itemPorPage"
          search
          pagination
          fieldVisibility
          :orderby="sortBy"
          pdf
          csv
          xls
          :titlePage="titlePage"
          :titlePDF="titlePDF"
          :items="listarCandidatos"
        >
        </fccTable>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import store from '@/store'

export default {
  data() {
    return {
      sortBy: 'nome',
      titlePage: 'Candidato(s) com Deficiência Auditiva',
      titleModal: '',
      titlePDF: 'Candidato(s) com Deficiência Auditiva',
      spi: '',
      todos: false,
      listarCandidatos: [],
      lstSpi: [],
      baseUrlPublicacao: '',
      mostraCandidatos: false,
      itemPorPage: '100',

      fieldsCandidatos: [
        { key: 'codcargo', label: 'Cargo', sortable: true, active: true },
        { key: 'cpf', label: 'CPF', sortable: true, active: true },
        { key: 'nome', label: 'Nome', sortable: true, active: true },
        {
          key: 'dataprocessamento',
          label: 'Data Processamento',
          type: 'datahora',
          sortable: true,
          active: true
        }
      ]
    }
  },
  methods: {
    ListandoSPI() {
      this.carregaTexto(this.codeMensagem('C01'))
      axios
        .get(
          this.baseUrlPublicacao + 'Publicacao/ListarPublicacaoSpisInscricoesAbertas',
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          this.lstSpi = response.data
        })
        .catch(this.setErrorSystem)
        .finally(this.carregaTexto)
    },
    ListandoCandidatosDeficienciaAuditiva() {
      this.mostraCandidatos = false
      this.carregaTexto(this.codeMensagem('C01'))
      axios
        .get(
          this.baseUrlPublicacao +
            'PublicacaoConcursoInscricao/CandidatosComDeficienciasAuditivas/' +
            this.spi,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          this.listarCandidatos = response.data
          this.mostraCandidatos = true
        })
        .catch(this.setErrorSystem)
        .finally(this.carregaTexto)
    }
  },
  mounted: function () {
    this.baseUrlPublicacao = store.state.baseUrlPublicacao
    this.ListandoSPI()
  }
}
</script>
